import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {fetchDestinationInfographic} from '../../../actions/infographic';

const mapStateToProps = (state) => ({
    lbsId: state.destination.details.lbsId
});

class DestinationInfographicLoaderComponent extends Component {
    static propTypes = {
        lbsId: PropTypes.string
    };

    componentDidMount() {
        this.props.dispatch(
            fetchDestinationInfographic(this.props.lbsId)
        );
    }

    render = () => <span />;
}

export const DestinationInfographicLoader = connect(mapStateToProps)(
    DestinationInfographicLoaderComponent
);
